import { render, staticRenderFns } from "./StandardFee.vue?vue&type=template&id=09604e3e&scoped=true&"
import script from "./StandardFee.vue?vue&type=script&lang=ts&"
export * from "./StandardFee.vue?vue&type=script&lang=ts&"
import style0 from "./StandardFee.vue?vue&type=style&index=0&id=09604e3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09604e3e",
  null
  
)

export default component.exports